import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  getBaseConfig
} from '../../api/comm';

interface StateType {
  attributeData?: any; // 全局基础类型对象
}

@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      attributeData: {
        chart: {}
      }
    };
  }

  // 获取全局基础类型列表
  @Action('setAttributeData')
  public async getAttributeData({ commit, state }: any, option: any) {
    return await getBaseConfig(option);
  }

  // 设置全局基础类型
  @Mutation('attributeData')
  public setAttributeData(state: StateType, payload: any) {
    return payload.result;
  }

  // 全局基础类型列表
  @Getter
  public attributeData(state: StateType) {
    return state.attributeData;
  }
}

export default new StoreModule();
